import { Alert } from "@cmsgov/ds-medicare-gov";
import React, { FunctionComponent, useContext } from "react";
import { FormattedMessage } from "react-intl-phraseapp";
import { Ga4EventType } from "../../../app/contexts/Analytics/types";
import { AppContext } from "../../../app/store";
import { PrintButton } from "../../../components";
import { uppercaseFirst, useTranslate } from "../../../helpers";

interface SummaryPageHeaderProps {
  firstName: string | undefined;
  overThirtyDaysSinceLogin?: boolean;
  hasCurrentCoverage: boolean;
}

const SummaryPageHeader: FunctionComponent<SummaryPageHeaderProps> = ({
  firstName,
  overThirtyDaysSinceLogin = false,
  hasCurrentCoverage,
}) => {
  const t = useTranslate();
  const {
    state: { mbpHandoffFailed },
  } = useContext(AppContext);
  const namedGreeting = overThirtyDaysSinceLogin
    ? "summary_page.header.greeting.over_thirty_days"
    : "summary_page.header.greeting";
  const anonymousGreeting = overThirtyDaysSinceLogin
    ? "summary_page.header.greeting.generic.over_thirty_days"
    : "summary_page.header.greeting.generic";
  const withPlanInfo = overThirtyDaysSinceLogin
    ? "summary_page.header.info.over_thirty_days"
    : "summary_page.header.info";
  const noPlanInfo = overThirtyDaysSinceLogin
    ? "summary_page.header.info.over_thirty_days.no_current_plan"
    : "summary_page.header.info.no_current_plan";
  const headerInfoContent = hasCurrentCoverage ? withPlanInfo : noPlanInfo;
  return (
    <div className="mct-c-summary-page-header">
      <div className="mct-c-summary-page-header__content">
        <h2 className="mct-c-summary-page-header__greeting">
          {firstName ? (
            <FormattedMessage
              id={namedGreeting}
              values={{ name: uppercaseFirst(firstName) }}
            />
          ) : (
            t(anonymousGreeting)
          )}
        </h2>
        <p className="mct-c-summary-page-header__info">
          {t(headerInfoContent)}
        </p>
        {mbpHandoffFailed && (
          <Alert
            className="mct-c-summary-page-header__alert ds-u-text-align--left ds-u-margin-bottom--0"
            heading={t("landing_page.mbp_error.heading")}
            hideIcon={true}
            role="alert"
            variation="error"
          >
            {t("landing_page.mbp_error.message")}
          </Alert>
        )}
      </div>
      <PrintButton
        className="ds-u-padding-left--0 mct-c-summary-page-header__print"
        tealiumProps={{
          event_action: "print link click",
          event_label: "account summary",
          other_props: { event_category: Ga4EventType.UI_INTERACTION },
        }}
      />
    </div>
  );
};

export default SummaryPageHeader;
